import React from "react"
import Rescue from "./Rescue"
import "./Rescues.css"

export default function Rescues(props) {

    const {rescues} = props

    return <div className="rescues">
        {rescues?.map(rescue => <Rescue key={rescue.id} rescue={rescue}/>)}
    </div>

}
